import React, { useEffect } from 'react';
import { useJoyride, STATUS, ACTIONS } from 'react-joyride';
import { BRAND_INTEL_TOUR_STEPS } from './brandIntelTourSteps';
import { TOUR_STYLES, TOUR_LOCALE } from './tourStyles';
import { useTour } from '../../store/context/tour.context';

// react-joyride v3 removed the `callback` prop that the rest of this file's
// logic was written against — passing it silently does nothing, so closing a
// tour never actually ended it. useJoyride()'s `state` (status/action) is the
// v3 replacement; watch it here and call onEnd ourselves.
const BrandIntelTourRunner = ({ onEnd }) => {
  const { Tour, state } = useJoyride({
    steps: BRAND_INTEL_TOUR_STEPS,
    run: true,
    continuous: true,
    showSkipButton: true,
    showProgress: true,
    disableBeacon: true,
    scrollToFirstStep: true,
    disableScrollParentFix: true,
    styles: TOUR_STYLES,
    locale: TOUR_LOCALE,
  });

  useEffect(() => {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(state.status) || state.action === ACTIONS.CLOSE) {
      onEnd();
    }
  }, [state.status, state.action, onEnd]);

  return Tour;
};

const BrandIntelTour = () => {
  const { brandIntelTourActive, brandIntelTourKey, endBrandIntelTour } = useTour();

  if (!brandIntelTourActive) return null;

  return <BrandIntelTourRunner key={brandIntelTourKey} onEnd={endBrandIntelTour} />;
};

export default BrandIntelTour;
